enum WizardOptionCondition {
  DEFAULT = 'default',
  SKIP_FORM = 'skip-form',
  SKIP_STEPS_FAIL = 'skip-steps-fail',
  SKIP_STEPS_SUCCESS = 'skip-steps-success',
}

enum WizardResultState {
  DEFAULT = 'default',
  EMPTY = 'empty',
}

enum ResultPageType {
  CARDS = 'cards',
  PRODUCTS_AND_ARTICLES = 'products & articles',
  GROWTHPLANS = 'growthplans',
}

export { ResultPageType, WizardOptionCondition, WizardResultState };
